import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App.js";
import { I18nProvider } from "./i18n.js";
import { SessionProvider } from "./session.js";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root non trovato");

createRoot(root).render(
  <StrictMode>
    <I18nProvider>
      <SessionProvider>
        <App />
      </SessionProvider>
    </I18nProvider>
  </StrictMode>,
);
